import React, { useEffect, useState } from 'react';

export default function PostcodesAdmin() {
  const [postcodes, setPostcodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [newCode, setNewCode] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let m = true;
    fetch('/api/approvedPostcodes')
      .then((r) => r.ok ? r.json() : Promise.reject('Failed to load'))
      .then((data) => { if (m) setPostcodes(Array.isArray(data) ? data : []); })
      .catch(() => setPostcodes([]))
      .finally(() => m && setLoading(false));
    return () => { m = false; };
  }, []);

  const save = async (arr) => {
    setSaving(true);
    setError('');
    setMessage('');
    try {
      const res = await fetch('/api/approvedPostcodes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(arr),
      });
      if (!res.ok) throw new Error(await res.text());
      setPostcodes(await res.json());
      setMessage('Saved.');
    } catch (e) {
      setError(e.message || String(e));
    } finally {
      setSaving(false);
    }
  };

  const handleAdd = () => {
    const code = newCode.toUpperCase().trim().replace(/\s+/g, ' ');
    if (!code || postcodes.includes(code)) { setNewCode(''); return; }
    setNewCode('');
    save([...postcodes, code]);
  };

  const handleRemove = (idx) => {
    if (!window.confirm(`Remove postcode "${postcodes[idx]}"?`)) return;
    save(postcodes.filter((_, i) => i !== idx));
  };

  return (
    <div>
      <div className="admin-header">
        <div>
          <h2>Approved Postcodes</h2>
          <p>Only residents with these postcodes can join the mailing list.</p>
        </div>
      </div>

      {error && <div className="admin-msg-error">{error}</div>}
      {message && <div className="admin-msg-success">{message}</div>}

      <div className="admin-form" style={{ maxWidth: 400 }}>
        <h3>Add postcode</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          <input
            placeholder="e.g. SW1A 1AA"
            value={newCode}
            onChange={(e) => setNewCode(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
          />
          <button className="btn btn-primary btn-sm" onClick={handleAdd} disabled={saving || !newCode.trim()}>
            Add
          </button>
        </div>
      </div>

      {loading ? (
        <p>Loading…</p>
      ) : (
        <div className="admin-list">
          {postcodes.length === 0
            ? <p style={{ color: 'var(--text-muted)' }}>No postcodes added yet.</p>
            : postcodes.map((p, i) => (
                <div className="admin-item" key={`${p}-${i}`}>
                  <div className="admin-item-info">
                    <div className="admin-item-title" style={{ fontFamily: 'monospace', letterSpacing: '0.05em' }}>{p}</div>
                  </div>
                  <div className="admin-item-btns">
                    <button className="btn btn-outline btn-sm" onClick={() => handleRemove(i)} disabled={saving}>Remove</button>
                  </div>
                </div>
              ))
          }
        </div>
      )}
    </div>
  );
}
